import { FlexiButton } from "@flexinet/ui-components";
import { MdRestoreFromTrash } from "react-icons/md";
import { Message, MessagePatch, MessageStatus } from "../types";

interface RestoreButtonProps {
    record: Message;
    onClick: (patch: MessagePatch) => void;
}

export const RestoreButton = ({ onClick }: RestoreButtonProps) => {
    return (
        <FlexiButton 
            variant={'outline'} 
            onClick={() => onClick({ status: MessageStatus.UNREAD })}
            leftSection={<MdRestoreFromTrash />}
        >
            Restore
        </FlexiButton>
    );
};
